import createFetchClient from "openapi-fetch";
import createClient from "openapi-react-query";
import type {
  paths,
  components,
  webhooks,
  operations,
} from "../../schema/schema";

const baseUrl = import.meta.env.VITE_PUBLIC_API_ADDRESS;
const apiClient = createFetchClient<paths>({ baseUrl });

export { type FetchResponse } from "openapi-fetch";
export type { paths, components, webhooks, operations };

export const $api = createClient(apiClient);
